import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useMedia } from '../../hooks/useMediaQuery';
import { useAuth } from '../../context/AuthContext';
import { primitiveColors, spacing } from './../../theming';
import VinCodeList from '../../components/vinCode/vinCodeList';
import PageContainer from './../../common/components/PageContainer';
import classes from './style.module.scss';
import VinCodeForm from '../../components/vinCode/vinCodeForm';
import { MobileTopMenu } from '../../common/components/mobileTopMenu/MobileTopMenu';
import { useSearchParams } from 'react-router-dom';
import { Flex, Input } from 'antd';
import { useDebounce } from '@uidotdev/usehooks';
import { SearchIcon } from '../../common/components/icons';
import { Suffix, searchKeyHandler } from './helper';

export default function Profile() {
    const [search, setSearch] = useState(localStorage.getItem('reportSearchText') || '');
    const debouncedSearch = useDebounce(search, 300);
    const searchInputRef = useRef(null);

    const { isSmallDevice, isExtraSmallDevice } = useMedia();
    const { t } = useTranslation(['profile', 'sidebar']);
    const { currentUser } = useAuth();
    const [urlSearchParams] = useSearchParams();

    const vinCode = urlSearchParams.get('vinCode');

    const handleSearchChange = value => {
        setSearch(value);
        localStorage.setItem('reportSearchText', value);
    };

    useEffect(() => {
        const searchInputKeyHandler = searchKeyHandler({ searchInputRef, handleSearchChange });

        window.addEventListener('keydown', searchInputKeyHandler);

        return () => window.removeEventListener('keydown', searchInputKeyHandler);
    }, []);

    return (
        <div>
            {isExtraSmallDevice && <MobileTopMenu />}

            <div className={classes['profileWrapper']} style={{ marginTop: isExtraSmallDevice ? spacing[5] : 0 }}>
                <div className={classes['block']}>
                    <div className={classes['title']}>{t('sidebar:my-reports')}</div>
                    <PageContainer
                        className={classes['section']}
                        style={{
                            padding: isExtraSmallDevice
                                ? `${spacing[4]} ${spacing[3]}`
                                : isSmallDevice
                                  ? `${spacing[6]} ${spacing[4]}`
                                  : spacing[6],
                            backgroundColor: primitiveColors.gray0,
                            height: '100%',
                        }}
                    >
                        <div className={classes['sub-title']}>{t('profile:vin-code')}</div>
                        <VinCodeForm vinCode={vinCode || ''} />
                    </PageContainer>
                    <PageContainer
                        className={classes['section']}
                        style={{
                            padding: isExtraSmallDevice
                                ? `${spacing[4]} ${spacing[3]}`
                                : isSmallDevice
                                  ? `${spacing[6]} ${spacing[4]}`
                                  : spacing[6],
                            backgroundColor: primitiveColors.gray0,
                            height: '100%',
                        }}
                    >
                        <Flex justify="space-between" align="center">
                            <div className={classes['sub-title']}>{t('profile:report-list')}</div>
                            <Input
                                name="search"
                                value={search}
                                className={classes.search}
                                ref={searchInputRef}
                                onChange={e => handleSearchChange(e.target.value)}
                                prefix={<SearchIcon onClick={() => handleSearchChange(search)} />}
                                suffix={
                                    <Suffix
                                        search={search}
                                        setSearch={setSearch}
                                        handleSearchChange={handleSearchChange}
                                    />
                                }
                                placeholder={t('profile:search') || 'Search report...'}
                            />
                        </Flex>
                        {currentUser && (
                            <VinCodeList
                                searchString={debouncedSearch.length > 2 ? debouncedSearch : ''}
                                consumerId={currentUser.id}
                            />
                        )}
                    </PageContainer>
                </div>
            </div>
        </div>
    );
}
